import React, { useState, useEffect, memo, Fragment, useMemo } from "react";
import { Row, Col, Dropdown, Button, Form } from "react-bootstrap";
import "./StatistikHeader.css";
import Card from "../../components/Card";

//Dashboar Service
import DashboardService from "../../services/pbumku/DashboardService";

// Components SKP Chart
import SKPChart from "./components/skp-chart";

// Components HACCP Chart
import { HACCPChart5 } from './components/haccp-chart-5';

// Components HACCP Chart Donut
import HACCPChart6 from './components/haccp-chart-6';

// Components StatCard
import StatCard from "./components/haccp-card";

// Icon Card Components
import { iconDoc, iconDoc2, iconHome, iconUserPlus } from "./components/icon-card";

const DashPasca = memo((props) => {
  const [upi, setUpi] = useState(0);
  const [haccp2, setHaccp2] = useState(0);
  const [upn, setUpn] = useState(0);
  let DashService = useMemo(() => new DashboardService(), []);
  const [isTrader, setIsTrader] = useState(false); // check yang login, dari trader atau bukan
  const [tahunsHonnest, setTahunsHonnest] = useState([]);
  const [haccp, setHaccp] = useState([]);
  const [jmlHaccp, setJmlHaccp] = useState([]);
  const [rekapSKP, setRekapSKP] = useState([]);
  const [limitSKP, setLimitSKP] = useState(10); // default limit SKP 20

  // Variabel untuk baca tanggal default
  const today = new Date();

  const tahunBerjalan = today.getFullYear();

  // inisialisasi state untuk tahun
  const [thnAwal, setThnAwal] = useState(`${tahunBerjalan}-01-01`);
  const [thnAkhir, setThnAkhir] = useState(`${tahunBerjalan}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`);

  // Tahun HACCP
  const [yearHACCP, setYearHACCP] = useState(today.getFullYear());

  // fungsi untuk baca tanggal default untuk PB-UMKU
  const getStartOfYear = () => {
    const now = new Date();
    return `${now.getFullYear()}-01-01`;
  };

  const getToday = () => {
    const now = new Date();
    return now.toISOString().slice(0, 10);
  };

  const formatDate = (date, isEndOfDay = false) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // bulan dimulai dari 0
    const dd = String(date.getDate()).padStart(2, "0");
    const time = isEndOfDay ? "23:59:59" : "00:00:00";
    return `${yyyy}-${mm}-${dd} ${time}`;
  };

  const [selectedBulan, setSelectedBulan] = useState(
    today.toLocaleString("id-ID", { month: "long" }) +
    " " +
    today.toLocaleString("default", { year: "numeric" })
  );

  // template startDate dan endDate PBUMKU
  const [tempStartDateUmku, setTempStartDateUmku] = useState(getStartOfYear());
  const [tempEndDateUmku, setTempEndDateUmku] = useState(getToday());

  // varibel Range Periode
  const [rangePeriode, setRangePeriode] = useState(`Bulan ${selectedBulan}`);
  const [rangePeriodeUmku, setRangePeriodeUmku] = useState(
    `Tahun ${new Date().getFullYear()}`
  );

  useEffect(() => {
    getRole();
    getUpiCnt();
    getUpnCnt();
    getHaccpPerbulan();
    getJmlHaccp();
    getRekapSKP()
  }, []);

  useEffect(() => {
    getUpiCnt();
    getSftCnt();
    getUpnCnt();
    getHaccpPerbulan();
    getJmlHaccp();
    getRekapSKP()
  }, [yearHACCP]);

  useEffect(() => {
    getRekapSKP()
  }, [limitSKP, thnAwal, thnAkhir]);

  const getUpiCnt = async () => {
    try {
      const response = await DashService.getUpi(yearHACCP);
      setUpi(response.data.nilai1);
    } catch (error) {
      console.log(error);
    }
  };

  const getSftCnt = async () => {
    try {
      const response = await DashService.getSft(yearHACCP);
      setHaccp2(response.data.nilai1);
    } catch (error) {
      console.log(error);
    }
  };

  const getUpnCnt = async () => {
    try {
      const response = await DashService.getUpn(yearHACCP);
      setUpn(response.data.nilai1);
    } catch (error) {
      console.log(error);
    }
  };

  const getHaccpPerbulan = async () => {
    try {
      const response = await DashService.getHACCPBulan(yearHACCP);;
      setHaccp(response.data)
    } catch (error) {
      console.log(error);
    }
  }

  const getJmlHaccp = async () => {
    try {
      const response = await DashService.getJumlahHACCP(
        formatDate(new Date(thnAwal)),
        formatDate(new Date(thnAkhir), true)
      );
      setJmlHaccp(response.data)
    } catch (error) {
      console.log(error);
    }
  }

  const getRekapSKP = async () => {
    try {
      const response = await DashService.getSKPPerPropinsi(
        formatDate(new Date(thnAwal)),
        formatDate(new Date(thnAkhir), true),
        limitSKP // <--  limit 
      );
      setRekapSKP(response.data)
    } catch (error) {
      console.log(error);
    }
  }

  const getRole = () => {
    const roleaturan = localStorage.getItem("role");
    const includedTrader = new Set(["4", "5"]);
    const isIncluded = includedTrader.has(roleaturan);
    if (isIncluded) {
      console.log("ini trader");
      setIsTrader(true);
    } else {
      setIsTrader(false);
    }
  };

  const handleSelectTahunHonnest = (value) => {
    setYearHACCP(value);
  };

  const handleClickButtonUmku = () => {
    const bulanIndonesia = new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    if (!tempStartDateUmku || !tempEndDateUmku) {
      alert("Tanggal awal dan akhir harus diisi!");
      return;
    }

    const start = new Date(tempStartDateUmku + "T00:00:00"); // buat Date dari string
    const end = new Date(tempEndDateUmku + "T23:59:59");

    if (start > end) {
      alert("Tanggal awal tidak boleh lebih besar dari tanggal akhir.");
      return;
    }

    if (start.getFullYear() !== end.getFullYear()) {
      alert("Periode tidak boleh lintas tahun.");
      return;
    }

    setThnAwal(tempStartDateUmku);
    setThnAkhir(tempEndDateUmku);

    const formattedStart = bulanIndonesia.format(new Date(tempStartDateUmku));
    const formattedEnd = bulanIndonesia.format(new Date(tempEndDateUmku));

    // setRangePeriodeUmku(`Periode ${tempStartDateUmku} s.d ${tempEndDateUmku} (Tahun ${start.getFullYear()})`);
    setRangePeriodeUmku(`Periode ${formattedStart} s.d ${formattedEnd}`);
  };

  const handleSelectSKP = (eventKey) => {
    setLimitSKP(eventKey === "all" ? null : parseInt(eventKey));
  };

  return (
    <Fragment>
      {!isTrader ? (
        <Fragment>
          {/* Statistik HACCP */}
          <Row>
            {/* Header */}
            <Col md="12">
              <div className="iq-navbar-header mb-4 px-4 rounded" style={{ position: "relative", top: "-12px" }}>
                {/* <div className="iq-navbar-header mb-4 bg-gradient-header"> */}
                <Row className="align-items-center">
                  {/* Kiri: Judul dan Info */}
                  <Col lg={6} md={12} className="mb-1 mb-lg-0 ">
                    <h2 className="text-white fw-bold mb-1">
                      Sertifikat Mutu Pasca Panen
                    </h2>
                    <h2 className="text-light mb-1">BPPMHKP</h2>
                    <h3 className="text-white">{rangePeriodeUmku}</h3>
                  </Col>

                  {/* Kanan: Form Periode */}
                  <Col lg={6} md={12}>
                    <Form.Group className="form-group">
                      <Form.Label className="text-white fw-semibold">
                        Periode
                      </Form.Label>
                      <div className="d-flex gap-2 align-items-end flex-wrap">
                        <div className="d-flex flex-column">
                          <Form.Label className="text-white small mb-1">
                            Dari
                          </Form.Label>
                          <Form.Control
                            type="date"
                            value={tempStartDateUmku}
                            onChange={(e) =>
                              setTempStartDateUmku(e.target.value)
                            }
                            style={{
                              backgroundColor: "white",
                              border: "1px solid #ccc",
                              minWidth: "140px",
                            }}
                          />
                        </div>
                        <div className="d-flex flex-column">
                          <Form.Label className="text-white small mb-1">
                            Sampai
                          </Form.Label>
                          <Form.Control
                            type="date"
                            value={tempEndDateUmku}
                            onChange={(e) => setTempEndDateUmku(e.target.value)}
                            style={{
                              backgroundColor: "white",
                              border: "1px solid #ccc",
                              minWidth: "140px",
                            }}
                          />
                        </div>
                        <Button
                          type="button"
                          variant="success"
                          className="mt-auto px-3"
                          onClick={handleClickButtonUmku}
                        >
                          Tampilkan
                        </Button>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md="12" lg="12">
              <div className="card mb-3">
                <div className="card-header">
                  <div className="header-title">
                    <h2 className="mb-2 text-primary fw-bold">
                      Sertifikasi Kelayakan Pengolahan
                    </h2>

                    {/* Flex Row untuk judul & dropdown sejajar */}
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                      <h5 className="card-title mb-0">
                        Tabel Jumlah SKP Per Provinsi
                      </h5>

                      <Dropdown onSelect={handleSelectSKP}>
                        <Dropdown.Toggle
                          variant="outline-dark"
                          size="sm"
                          id="dropdown-limit"
                          style={{
                            fontSize: "1rem",
                            padding: "6px 12px",
                            minWidth: "100px",
                          }}
                        >
                          {limitSKP ? `Top : ${limitSKP}` : "Semua"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          align="end"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#212529",
                            border: "1px solid #999",
                            boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
                            zIndex: 1050,
                            fontSize: "1rem",
                            minWidth: "130px",
                            padding: "8px 0",
                          }}
                        >
                          <Dropdown.Item eventKey="all" style={{ padding: "8px 16px" }}>Semua</Dropdown.Item>
                          <Dropdown.Item eventKey="5" style={{ padding: "8px 16px" }}>5</Dropdown.Item>
                          <Dropdown.Item eventKey="10" style={{ padding: "8px 16px" }}>10</Dropdown.Item>
                          <Dropdown.Item eventKey="15" style={{ padding: "8px 16px" }}>15</Dropdown.Item>
                          <Dropdown.Item eventKey="20" style={{ padding: "8px 16px" }}>20</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {rekapSKP.length > 0 ? (
                    <Fragment> {/* Use Fragment to group chart and badge */}
                      <SKPChart rekapSKP={rekapSKP} />
                    </Fragment>
                  ) : (
                    <p>Memuat data chart...</p>
                  )}
                </div>
              </div>
            </Col>
            <Col md="12" lg="12">
              <Card className="bg-white mt-1">
                <Card.Body>
                  <div className="d-flex flex-column">
                    {/* Header dengan judul dan dropdown tahun */}
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h2 className="mb-2 text-primary">Sertifikasi HACCP</h2>
                        <h3 className="text-secondary">Tahun {yearHACCP}</h3>
                      </div>

                      <div className="d-flex align-items-center text-dark">
                        <span className="me-2 fw-bold">Tahun</span>
                        <Dropdown onSelect={handleSelectTahunHonnest}>
                          <Dropdown.Toggle
                            as={Button}
                            variant="outline-dark" // Ubah outline-light → outline-dark
                            size="sm"
                            className="border border-dark text-dark bg-light" // Tambahan styling
                          >
                            {yearHACCP}
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="shadow">
                            {tahunsHonnest.map((tahun) => (
                              <Dropdown.Item
                                key={tahun.tahun}
                                eventKey={tahun.tahun}
                              >
                                {tahun.tahun}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>

                    <div className="border rounded">
                      <Row>
                        <Col lg="3" md="6">
                          <StatCard
                            bgColor="bg-soft-warning"
                            svgIcon={iconDoc}
                            value={haccp2}
                            label="Sertifikasi HACCP"
                          />
                        </Col>
                        <Col lg="3" md="6" className="col-lg-3 col-md-6">
                          <StatCard
                            bgColor="bg-soft-info"
                            svgIcon={iconHome}
                            value={upi}
                            label="UPI Tersertifikasi"
                          />
                        </Col>
                        <Col lg="3" md="6">
                          <StatCard
                            bgColor="bg-soft-primary"
                            svgIcon={iconUserPlus}
                            value={upn}
                            label="UPI Baru"
                          />
                        </Col>

                        <Col lg="3" md="6">
                          <StatCard
                            bgColor="bg-soft-danger"
                            svgIcon={iconDoc2}
                            value={upi - upn}
                            label="UPI LAMA"
                          />
                        </Col>
                      </Row>

                      <Row className="g-3">
                        {/* Card Jumlah Sertifikat HACCP Terbit (80%) */}
                        <Col md="8">
                          <div className="card h-80">
                            <div className="flex-wrap card-header d-flex justify-content-between">
                              <div className="header-title">
                                <h5 className="card-title">Jumlah Sertifikat HACCP Terbit</h5>
                              </div>
                              <div className="header-title">
                                {/* <h7 className="text-primary mb-0">Tahun {thnIni}</h7> */}
                              </div>
                            </div>
                            <div className="card-body">
                              <HACCPChart5 haccp={haccp} />
                            </div>
                          </div>
                        </Col>

                        {/* Card Tambahan (20%) */}
                        <Col md="4">
                          <div className="card h-65">
                            <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                              {/* Judul dan Tahun di atas chart */}
                              <div className="mb-0">
                                <h5 className="card-title mb-1">Total HACCP Terbit</h5>
                                {/* <h7 className="text-primary">Tahun {thnIni}</h7> */}
                              </div>

                              {/* Donut Chart */}
                              <div style={{ position: 'relative', width: 250, height: 250 }}>
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -120%)',
                                    textAlign: 'center',
                                    pointerEvents: 'none',
                                  }}
                                >
                                  <h6 style={{ margin: 0, fontSize: '13px', fontWeight: 500, color: '#666' }}>
                                    JUMLAH
                                  </h6>
                                  <p style={{ margin: 0, fontSize: '16px', fontWeight: 700 }}>{jmlHaccp.JUMLAH}</p>
                                </div>
                                <HACCPChart6 jmlHaccp={jmlHaccp} />
                              </div>
                            </div>
                          </div >
                        </Col >
                      </Row >

                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Fragment>
      ) : (
        <Fragment>
          <Row>
            <Col md="12">
              <div className="d-flex justify-content-between flex-wrap iq-navbar-header mb-4">
                <div>
                  <h1 className="text-white">SIAP MUTU</h1>
                  <h3 className="text-light">
                    Sistem Informasi Aplikasi Pelayanan Mutu{" "}
                  </h3>
                </div>
              </div>
            </Col>
          </Row>
        </Fragment>
      )}
    </Fragment>
  );
});

export default DashPasca;
